module.exports = __webpack_public_path__ + "static/img/ptGame5.490eb62.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame5.png
// module id = CH8E
// module chunks = 3